export default {
  computed: {
    questionUiV2Enabled() {
      return this.$store.getters['app/questionUiV2Enabled'];
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    getCorrectRouteName(flashcardType) {
      if (flashcardType === 'Flipcard' && this.currentRouteName === 'categories#flashcard-v2') return 'categories#flashcard';
      if (flashcardType === 'Flipcard' && this.currentRouteName === 'categories#flashcard') return 'categories#flashcard';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'categories#flashcard-v2') return 'categories#flashcard';
      if (this.questionUiV2Enabled && this.currentRouteName === 'categories#flashcard') return 'categories#flashcard-v2';
      if (this.questionUiV2Enabled && this.currentRouteName === 'scenarios#flashcard') return 'scenarios#flashcard-v2';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'scenarios#flashcard-v2') return 'scenarios#flashcard';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'qotd#flashcard-v2') return 'qotd#index';
      if (this.questionUiV2Enabled && this.currentRouteName === 'qotd#index') return 'qotd#flashcard-v2';
      return this.currentRouteName;
    },
  },
};
